'use client'

import React from 'react'
import { IconShoppingCart } from '@tabler/icons-react'

import { formatPrice } from 'modules/products'
import { isNotNilOrEmpty } from 'shared/utils/ramda'
import { addTestId } from 'shared/utils/tests'

import { useDisplayCart } from '../store/cartStore'

import styles from './CartButtonMobile.module.scss'

interface CartButtonMobileProps
  extends React.HTMLAttributes<HTMLButtonElement> {
  onClick: () => void
  open: boolean
}

const CartButtonMobile = ({ onClick, open }: CartButtonMobileProps) => {
  const cart = useDisplayCart()
  const hasItems = isNotNilOrEmpty(cart?.items)

  const cartItemsQuantity = cart?.items?.length || 0
  const paymentValue = cart?.paymentValue?.value || 0
  const deliveryPrice = cart?.deliveryCost?.value || 0

  const totalPrice = formatPrice(paymentValue - deliveryPrice)

  return (
    <button
      className={styles.wrapper}
      id='cart_button_mobile'
      onClick={onClick}
      role='button'
      aria-expanded={open}
      aria-controls='cart_drawer'
      {...addTestId('cart-drawer-trigger-button')}
    >
      {cartItemsQuantity ? (
        <p className={styles.productsNumber} id='productsNumber'>
          {cartItemsQuantity}
        </p>
      ) : null}
      <IconShoppingCart />
      <div
        className={styles.iconLabel}
        dangerouslySetInnerHTML={{ __html: hasItems ? totalPrice : '0,00 zł' }}
      />
    </button>
  )
}

export default CartButtonMobile

